import { TileSetMapType, CHARACTER_DIRECTION } from "common/model";

const landscapeLayer1 = [
  [23, 22, 22, 22, 22],
  [31, 26, 31, 31, 23],
  [31, 26, 23, 23, 23],
  [22, 26, 31, 31, 23],
  [23, 23, 17, 17, 17],
];
const landscapeLayer2 = [
  [42, 0, 0, 8, 35],
  [0, 13, 0, 0, 0],
  [0, 22, 0, 0, 38],
  [1, 13, 0, 0, 36],
  [0, 36, 14, 49, 19],
];
const landscapeLayer3 = [
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0],
  [0, 0, 0, 0, 37],
];

const landscape = [landscapeLayer1, landscapeLayer2, landscapeLayer3];

const map: TileSetMapType = {
  character: {
    direction: CHARACTER_DIRECTION.CHARACTER_DIRECTION_MINUS_X,
  },
  landscape: landscape,
};

export default map;
